import { Module } from 'vuex'
import { RootState } from '@/store/types'
import PStorage, {
    THEME,
    DARKNESS,
    DRAG_DROP_VAULTS,
    SHOW_TOOLTIPS,
    STRENGTH_INDICATOR
} from '@/util/PStorage'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import UIState from './types'

const state: UIState = {
    size: 'lg-desktop',
    treeOpen: false,
    page: 'editor',
    searchOpen: false,
    searchTerm: '',
    searchFocused: false,
    theme: PStorage.getOrDefault(THEME, 'blue'),
    darkness: PStorage.getOrDefault(DARKNESS, 'normal'),
    dragDropVaults: PStorage.getOrDefault(DRAG_DROP_VAULTS, true),
    showTooltips: PStorage.getOrDefault(SHOW_TOOLTIPS, true),
    showStrengthIndicator: PStorage.getOrDefault(STRENGTH_INDICATOR, true),
    lastUrl: undefined,
    isOnline: false
}

const ui: Module<UIState, RootState> = {
    state,
    getters,
    actions,
    mutations
}

export default ui
